import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Select,
  Tooltip,
  MenuItem,
  Checkbox,
  InputLabel,
  FormControl,
  ListItemText,
  OutlinedInput,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { languageOption } from '../../helpers/options';

const DictionaryFilter = ({
  filter,
  options,
  multipleLanguage = true,
  onFilterReset,
  onFilterSelect,
  onDownload,
}) => {
  const { language, additions } = filter;
  const { t } = useTranslation(['promptbar', 'common', 'filter']);

  const handleDownload = () => {
    onDownload?.();
  };

  return (
    <Box
      sx={{
        pb: '1rem',
        m: '0 -0.5rem',
        display: 'flex',
        alignItems: 'end',
        flexWrap: 'wrap',
        width: 'fit-content',
      }}
    >
      <FormControl size="small" variant="standard">
        <InputLabel id="Select-102-label" shrink={false}>
          {t('common:dictionaryLanguage')}
        </InputLabel>
        <Select
          labelId="Select-102-label"
          id="Select-102"
          name="language"
          multiple={multipleLanguage}
          value={language}
          onChange={onFilterSelect}
          input={<OutlinedInput label={t('common:dictionaryLanguage')} />}
          renderValue={selected => {
            if (Array.isArray(selected)) {
              return selected.map(el => el.toUpperCase()).join(', ');
            } else {
              return selected.toUpperCase();
            }
          }}
          IconComponent={KeyboardArrowDownIcon}
          MenuProps={{ size: 'small', autoFocus: false }}
        >
          {languageOption.map(lng => (
            <MenuItem key={lng} value={lng}>
              <Checkbox checked={language?.indexOf(lng) > -1} />
              <ListItemText primary={lng.toUpperCase()} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl size="small" variant="standard">
        <InputLabel id="Select-103-label" shrink={false}>
          {t('common:visibleColumns')}
        </InputLabel>
        <Select
          labelId="Select-103-label"
          id="Select-103"
          name="additions"
          multiple
          value={additions}
          onChange={onFilterSelect}
          input={<OutlinedInput label={t('common:visibleColumns')} />}
          renderValue={selected =>
            selected.map(el => t(`filter:${el}`)).join(', ')
          }
          IconComponent={KeyboardArrowDownIcon}
          MenuProps={{ size: 'small', autoFocus: false }}
        >
          {options.map(item => {
            return (
              <MenuItem key={item} value={item}>
                <Checkbox checked={additions?.indexOf(item) > -1} />
                <ListItemText primary={t(`filter:${item}`)} />
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>

      <Box sx={{ ml: '0.5rem', mb: '0.5rem' }}>
        <Tooltip title={t('promptbar:resetTitle')} arrow>
          <Button
            color="secondary"
            variant="contained"
            sx={{ mr: '0.5rem' }}
            onClick={onFilterReset}
          >
            {t('promptbar:reset')}
          </Button>
        </Tooltip>

        {onDownload && (
          <Tooltip title={t('promptbar:downloadExcel')} arrow>
            <Button
              color="primary"
              variant="contained"
              onClick={handleDownload}
            >
              {t('promptbar:download')}
            </Button>
          </Tooltip>
        )}
      </Box>
    </Box>
  );
};

DictionaryFilter.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  filter: PropTypes.object.isRequired,
  onFilterReset: PropTypes.func.isRequired,
  onFilterSelect: PropTypes.func.isRequired,
  multipleLanguage: PropTypes.bool,
  onDownload: PropTypes.func,
};

export default DictionaryFilter;
